var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAnalysisDropapin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 14.168c3.746.42 7 1.655 7 3.832 0 2.748-5.184 4-10 4S2 20.748 2 18c0-2.177 3.254-3.412 7-3.832v2.013c-3.288.41-5 1.414-5 1.819 0 .514 2.75 2 8 2s8-1.486 8-2c0-.405-1.712-1.409-5-1.819zM11.998 2C14.207 2 16 3.794 16 6c0 1.858-1.28 3.411-3 3.858V18h-2V9.858c-.691-.173-1.324-.529-1.83-1.03-1.14-1.145-1.48-2.864-.862-4.357.618-1.493 2.074-2.468 3.69-2.471zm.004 2c-.808 0-1.537.488-1.847 1.235-.31.746-.14 1.606.43 2.179.374.376.883.586 1.413.585 1.09-.024 1.96-.912 1.96-2 0-1.087-.87-1.975-1.956-1.999z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalysisDropapin);
export default __webpack_public_path__ + "static/media/icon-analysis-dropapin.eac1d1c1e7049abb294f92d115bbd490.svg";
export { ForwardRef as ReactComponent };